module.exports = __webpack_public_path__ + "media/images/arrow-down-green-16320786ecaf31823211811812b76943.svg";